import { render, staticRenderFns } from "./selection-3.vue?vue&type=template&id=3934c8b8&scoped=true&"
import script from "./selection-3.vue?vue&type=script&lang=js&"
export * from "./selection-3.vue?vue&type=script&lang=js&"
import style0 from "./selection-3.vue?vue&type=style&index=0&id=3934c8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3934c8b8",
  null
  
)

export default component.exports